import NotificationConfigureStore from '../stores/notification-configure-store';
import { Recipient } from '../types/notification-settings-types';

export const setIsLoadingTestNotification = (isLoading: boolean) => {
  NotificationConfigureStore.isLoadingTestNotification = isLoading;
};

export const setErrorMessage = (message: string) => {
  NotificationConfigureStore.errorMessage = message;
};

export const clearErrorMessage = () => {
  NotificationConfigureStore.errorMessage = null;
};

export const closeNotificationModal = (): void => {
  NotificationConfigureStore.isModalVisible = false;
};

export const setPotentialRecipients = (potentialRecipients: Recipient[]) => {
  NotificationConfigureStore.potentialRecipients = potentialRecipients;
};
